import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import TextInput from '../../../common/TextInput/';
import { isValidEmail } from '../../../helpers/utils';
import { forgotPasswordRequested, clearErrorMessages } from './../actions';
import LoadingComponent from '../../../common/LoadingComponent';
import './styles.scss';
import { getForgotPasswordError, getForgotPasswordLoading } from '../selectors';

function ForgotForm({
    isLoading,
    requestForgetPassword,
    errorMessage,
    clearErrorState,
}) {
    const [email, setemail] = useState('');
    useEffect(() => {
        clearErrorState();
    }, []);

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={isLoading} />
        </div>
    );

    const buttonText = isLoading ? loader : 'Next';
    return (
        <>
            {errorMessage ? <p className="error">{errorMessage}</p> : null}
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    requestForgetPassword(email);
                }}
            >
                <div className="filter-form">
                    <h2 className="mb-24 loginTitle">Forgot Password</h2>
                    <div className="signin-seperator">
                        <div className="signin-divider"></div>
                    </div>
                    <div className="customInput">
                        <h3 className="titleStyle2">email</h3>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text icon-latest-envelop"></span>
                            </div>
                            <TextInput
                                type="text"
                                onChange={(event) =>
                                    setemail(event.target.value)
                                }
                                title="No empty spaces or special characters allowed"
                                value={email}
                                placeholder={'email'}
                                required="required"
                            />
                        </div>
                    </div>
                    <button
                        disabled={!isValidEmail(email)}
                        type="submit"
                        className="btn btn-custom btn-block"
                    >
                        {buttonText}
                    </button>
                </div>
            </form>
        </>
    );
}

ForgotForm.propTypes = {
    // function to be called when form is submitted
    requestForgetPassword: PropTypes.func.isRequired,

    // error message to be shown when something goes wrong with login request
    errorMessage: PropTypes.string,

    // function to clear error message
    clearErrorState: PropTypes.func.isRequired,

    isLoading: PropTypes.boolean,
};

ForgotForm.defaultProps = {
    errorMessage: null,
    isLoading: false,
};

const mapStateToProps = (state) => {
    return {
        errorMessage: getForgotPasswordError(state),
        isLoading: getForgotPasswordLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        requestForgetPassword: (email) =>
            dispatch(forgotPasswordRequested(email)),
        clearErrorState: () => dispatch(clearErrorMessages()),
    };
};

const ConnectedForgotForm = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ForgotForm);

export default ConnectedForgotForm;
